import { defineMessages } from 'react-intl';

export const keyboardShortcutMessages = defineMessages({
  pullRequestKeyboardShortcutsTitle: {
    id: 'frontbucket.keyboardShortcuts.pullRequest.pullRequestKeyboardShortcutsTitle',
    description:
      'Title for the group of pull request-related keyboard shortcuts',
    defaultMessage: 'Pull request actions',
  },
  overviewTabShortcut: {
    id: 'frontbucket.keyboardShortcuts.pullRequest.overviewTabShortcut',
    description:
      'Description of a keyboard shortcut to navigate to the overview tab',
    defaultMessage: 'Go to Overview tab',
  },
  filesChangedTabShortcut: {
    id: 'frontbucket.keyboardShortcuts.pullRequest.filesChangedTabShortcut',
    description:
      'Description of a keyboard shortcut to navigate to the files changed tab',
    defaultMessage: 'Go to Files changed tab',
  },
  commitsTabShortcut: {
    id: 'frontbucket.keyboardShortcuts.pullRequest.commitsTabShortcut',
    description:
      'Description of a keyboard shortcut to navigate to the commits tab',
    defaultMessage: 'Go to Commits tab',
  },
  fileTreeToggleExpandShortcut: {
    id: 'frontbucket.keyboardShortcuts.pullRequest.fileTreeToggleExpandShortcut',
    description:
      'Description of a keyboard shortcut to expand the file tree sidebar',
    defaultMessage: 'Expand file tree',
  },
  fileTreeToggleCollapseShortcut: {
    id: 'frontbucket.keyboardShortcuts.pullRequest.fileTreeToggleCollapseShortcut',
    description:
      'Description of a keyboard shortcut to collapse the file tree sidebar',
    defaultMessage: 'Collapse file tree',
  },
  finishReview: {
    id: 'frontbucket.keyboardShortcuts.pullRequest.finishReview',
    description:
      'Description of a keyboard shortcut to finish a pull request review',
    defaultMessage: 'Finish review',
  },
  watchPullRequestShortcut: {
    id: 'frontbucket.keyboardShortcuts.pullRequest.watchPullRequestShortcut',
    description: 'Description of a keyboard shortcut to watch a pull request',
    defaultMessage: 'Watch pull request',
  },
  markFileViewedShortcut: {
    id: 'frontbucket.keyboardShortcuts.pullRequest.markFileViewedShortcut',
    description: 'Description of a keyboard shortcut to mark a file as viewed',
    defaultMessage: 'Mark file as viewed',
  },
  unmarkFileViewedShortcut: {
    id: 'frontbucket.keyboardShortcuts.pullRequest.unmarkFileViewedShortcut',
    description:
      'Description of a keyboard shortcut to unmark a file as viewed',
    defaultMessage: 'Unmark file as viewed',
  },
});
